export const STORES_IMPORT_LIST_PATH = "/stores-import";
export const STORES_IMPORT_CREATE_VIEW_PATH = "/stores-import/create";
